import ConfirmationDialog from "../ConfirmationDialog";
import React from "react";

export const DeleteDialog = ({...props }) =>
    <ConfirmationDialog
        {...props}
        onClose = { props.onClose }
        cancelButton={{
            action: props.onClose,
            label: 'No, Cancel'
        }}
        acceptButton={{
            action: props.onAccept,
            label: 'Yes, Delete'
        }}
        header="Do you want to delete this item?"
    />;

export default DeleteDialog;
